import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * LEGACY: Controls whether public workflowsets are publicly visible or not. NO LONGER USED IN CODE.
 */
export const schema = z.boolean();

export type PublicWorkflowsets = z.infer<typeof schema>;

export const definition = define({
  key: 'public_workflowsets',
  schema,
  label: 'Show Public Workflowsets',
  description: 'LEGACY: Controls whether public workflowsets are publicly visible or not.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.WORKFLOWS.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.REGION, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: true,
  deprecated: true,
});
